import { createFeature, createReducer, on } from '@ngrx/store';
import { StorageActions } from './storage.actions';

export interface StorageState {
  hydrated: boolean;
}

const initialState: StorageState = { hydrated: false };

/**
 * Hydration happens in an app initializer, so by the time anything renders this is already
 * true and no component needs to guard on it. It exists for logic that spans slices and
 * cannot rely on being started after the initializer — `StorageEffects` uses the action
 * itself for that.
 */
export const storageFeature = createFeature({
  name: 'storage',
  reducer: createReducer(
    initialState,
    on(StorageActions.hydrated, (): StorageState => ({ hydrated: true })),
  ),
});
